/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MeetDayStudentPagedData } from '../../models/meet-day-student-paged-data';

export interface GetMeetDayStudents$Params {
  meetDayId: string;
  PageNumber?: number;
  PageSize?: number;
}

export function getMeetDayStudents(http: HttpClient, rootUrl: string, params: GetMeetDayStudents$Params, context?: HttpContext): Observable<StrictHttpResponse<MeetDayStudentPagedData>> {
  const rb = new RequestBuilder(rootUrl, getMeetDayStudents.PATH, 'get');
  if (params) {
    rb.path('meetDayId', params.meetDayId, {});
    rb.query('PageNumber', params.PageNumber, {});
    rb.query('PageSize', params.PageSize, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MeetDayStudentPagedData>;
    })
  );
}

getMeetDayStudents.PATH = '/meetday/{meetDayId}/student';
